import type { ITimeLine } from 'blocks/TimeLine'

import { useCallback } from 'react'

export const useUpdateStartTime = ({
  now,
  startTime,
  scaleDivision,
  valueSection,
  onUpdateStartTime,
}: Pick<ITimeLine, 'onUpdateStartTime'> & {
  now: number
  startTime: number
  scaleDivision: number
  valueSection: number
}) => {
  const loadNextPeriod = useCallback(() => {
    const newStartTime = startTime + scaleDivision * valueSection
    onUpdateStartTime?.({ startTime: newStartTime })
  }, [startTime, onUpdateStartTime, scaleDivision, valueSection])

  const loadPrevPeriod = useCallback(() => {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    let newStartTime = startTime - scaleDivision * valueSection
    if (newStartTime >= today.getTime() && newStartTime < now - scaleDivision) {
      newStartTime = now // today cannot be shifter in the past
    }
    onUpdateStartTime?.({ startTime: newStartTime })
  }, [startTime, onUpdateStartTime, scaleDivision, valueSection, now])

  return { loadNextPeriod, loadPrevPeriod }
}
